import { useFlags } from "launchdarkly-react-client-sdk";
import { useUser } from "@auth0/nextjs-auth0/client";
import {
  BadStandingBanner,
  BuyFeeBanner,
  isAllowedBuyFeeBannerPath,
} from "@/components/Banners";
import { useRouter } from "next/router";

export default function useBanners() {
  const { user } = useUser();
  const { pathname } = useRouter();
  const { displayBadStandingUserAccountBanner, auctionBuyFeeBanner } =
    useFlags<{
      displayBadStandingUserAccountBanner: boolean | undefined;
      auctionBuyFeeBanner:
        | { enabled: boolean; linkLabel: string; message: string }
        | undefined;
    }>();

  const isBadStandingBannerVisible = Boolean(
    displayBadStandingUserAccountBanner &&
      user &&
      user.representativeId &&
      !user.isInGoodStanding,
  );

  const isBuyFeeBannerVisible = Boolean(
    auctionBuyFeeBanner?.enabled && isAllowedBuyFeeBannerPath(pathname),
  );

  const banners = [
    isBadStandingBannerVisible && <BadStandingBanner key="badStandingBanner" />,
    isBuyFeeBannerVisible && <BuyFeeBanner key="buyFeeBanner" />,
  ].filter(Boolean);

  return {
    banners,
    openBannerCount: banners.length,
  };
}
